"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const SubMenu_1 = require("../../styled/SubMenu");
const Button_1 = require("../../styled/Button");
/**
 * Renders a sub menu item
 */
exports.SubMenuItem = react_1.default.forwardRef(({ label, isActive = false, onTrigger, ...props }, forwardedRef) => {
    return (react_1.default.createElement(SubMenu_1.Li, { ...(0, oxygen_config_1.getTestAttributes)(`${props.testId}_ITEM_${label.replaceAll(' ', '-')}`) },
        react_1.default.createElement(Button_1.Button, { ref: forwardedRef, ...props, isActive: isActive, onClick: onTrigger, subItem: true }, label)));
});
exports.SubMenuItem.displayName = 'SubMenuItem';
